import { Link } from "react-router-dom";
import { Presentation } from "lucide-react";
import { WIDE_CONTENT_WRAP } from "../../constants/layout";

/** Écran plein page pour routes désactivées en session démo (compte, auth). */
export default function DemoBlockedMessage({ title = "Indisponible en démonstration", children }) {
  return (
    <div className="min-h-screen bg-[#f5f7fa] py-16">
      <div className={WIDE_CONTENT_WRAP}>
        <div className="mx-auto max-w-lg rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-100 text-amber-700">
            <Presentation className="h-6 w-6" aria-hidden />
          </div>
          <h1 className="font-heading text-xl font-bold text-gray-900">{title}</h1>
          <p className="mt-3 text-sm leading-relaxed text-gray-600">
            {children ||
              "Cette fonctionnalité est masquée pendant la présentation pour éviter toute action sur des comptes ou commandes réels."}
          </p>
          <Link
            to="/catalogue"
            className="mt-6 inline-flex items-center justify-center rounded-xl bg-[#190276] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#130160]"
          >
            Continuer la visite — catalogue
          </Link>
        </div>
      </div>
    </div>
  );
}
